import {
    Avatar,
    CardHeader,
    IconButton,
    Skeleton,
    Stack,
    Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import { TIPPSPIEL_BOX_SHADOW } from "../../../../styles";

export const HeadlineTeaserStack = styled(Stack)({
    flexDirection: "row",
    alignItems: "center",
});

export const HeadlineTeaserBoxTypography = styled(Typography)({
    justifyContent: "left",
    textTransform: "none",
    fontWeight: "normal",
    fontSize: "14px",
    color: "var(--community-color-secondary-text)",
});

export const HeadlinePostInputButton = styled(IconButton)({
    cursor: "pointer",
    borderRadius: "90px",
    padding: "8px",
    backgroundColor: "var(--community-color-transparent-black-05)",
    "&:hover": {
        backgroundColor: "var(--community-color-transparent-black-05)",
    },
    "& > svg": {
        width: "20px",
        height: "20px",
    },
});

export const HeadlineTeaserAvatar = styled(Avatar)({
    width: "40px",
    height: "40px",
});

export const HeadlineTeaserAvatarSkeleton = styled(Skeleton)({
    width: "40px",
    height: "40px",
    marginRight: "12px",
});

const borderRadius = "12px";

export const GroupHeadlineTeaserStack = styled(Stack)({
    backgroundColor: "var(--community-header-background-color)",
    borderColor: "var(--community-color-dark-gray)",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "left",
    background: "var(--community-color-snow-white)",
    padding: "12px",
    gap: "12px",
    borderRadius: `${borderRadius}`,
    cursor: "pointer",
    border: "none",
    boxShadow: TIPPSPIEL_BOX_SHADOW,
    WebkitTapHighlightColor: "transparent",
});

export const AvatarCardHeader = styled(CardHeader)({
    alignItems: "flex-start",
    padding: "0",
    "& > .MuiCardHeader-avatar": {
        marginRight: "12px",
    },
});
